import { atom, selectorFamily, useRecoilState, useRecoilValue } from 'recoil'
import { userState } from '.'
import { levelMenuState, sdForGroupState } from './portale'

export const titles: Record<string, string> = {
    "do/fiscale": "Fiscale",
    "do/paghe": "Paghe",
    "do/affgen": "Affari Generali",
    "do/servcom": "Servizi Comuni",
    "do/crm": "CRM",
    "do/assoc": "Associativi",
    "do/tecn": "Tecnologici",
    "do/azienda": "Azienda",
    "/admin": "Amministrazione",
    "/admin/:id": "Amministrazione modifica",
}

export const titlesArea: Record<string, string> = {
    "fiscale": "Fiscale",
    "paghe": "Paghe",
    "affgen": "Affari Generali",
    "servcom": "Servizi Comuni",
    "crm": "CRM",
    "assoc": "Associativi",
    "tecn": "Tecnologici",
    "azienda": "Azienda",
    "informativa": "Informativa",
    "docpub": "Documenti pubblici",
    "stampepub": "Stampe pubbliche",
}

const roles: Record<string, number> = {
    "admin": 9,
    "globale": 6,
    "nazionale": 5,
    "regionale": 4,
    "provincia": 3,
    "ufficio": 2,
    "azienda": 1,
    "undefined": 0,
}

const getRolePriority = (role?: string) => {
    if (role) {
        let rv = roles[role]
        if (rv) return rv
    }
    return 0
}
const isEnabled = (minPriority: number, role?: string) => getRolePriority(role) >= minPriority

export type MenuLivelliItemType = {
    index: number,
    label: string,
    pathext: string,
    minprio: number,
    path: string,
}
export type MenuLivelliDefType = MenuLivelliItemType[]

// I livello sono questi, non tutti sono disponibili per l'utente
// NOTA: Per avere lo stesso modello del vecchio portale il tab SIXTEMA
//       è disponibile dal globale in su (globale e admin) per cui la
//       minprio sarà quella del globale: 6
const menuLevelsDef: MenuLivelliDefType = [
    { index: 0, minprio: 6, path: '/', pathext: 'sixt', label: 'Sixtema' },
    { index: 1, minprio: 5, path: '/', pathext: 'nazi', label: 'Nazionale' },
    { index: 2, minprio: 4, path: '/', pathext: 'regi', label: 'Regionale' },
    { index: 3, minprio: 3, path: '/', pathext: 'prov', label: 'Provincia' },
    { index: 4, minprio: 2, path: '/', pathext: 'uffi', label: 'Ufficio' },
    { index: 5, minprio: 1, path: '/', pathext: 'azie', label: 'Azienda' },
]

// il menuLevels come dictionary lo mettiamo in un atomo, così è memoizzato
const getMenuLevelsDic = () => {
    const rv: Record<string, MenuLivelliItemType> = {}
    menuLevelsDef.forEach(m => rv[m.pathext] = m)
    return rv
}
const menuLevelsDicState = atom({
    key: 'menuLevelsDicState',
    default: getMenuLevelsDic()
})
export const useMenuLevels = () => ({ menuLevelsDef, menuLevelsDic: useRecoilValue(menuLevelsDicState) })

export const getMenuLivelli = (role: string, base: string) => menuLevelsDef
    .filter(x => isEnabled(x.minprio, role))
    .map<MenuLivelliItemType>(x => ({ ...x, path: `/${base}/${x.pathext}` }))

const menuLevelsSelector = selectorFamily({
    key: "menuLevelsSelector",
    get: (base: string) => ({ get }) => {
        const user = get(userState)
        const role = user?.role ?? 'undefined'
        // console.log(`menuLevelsSelector: ${role} - ${base}`)
        const rv = getMenuLivelli(role, base)
        return rv;
    }
})
export const useEnabledMenuLevels = (base: string) => useRecoilValue(menuLevelsSelector(base))


const menuIndexSelectedState = atom({
    key: "menuIndexSelectedState",
    default: 0
})
export const useSelectedMenuIndex = () => useRecoilState(menuIndexSelectedState)

export const useLevelMenu = (area: string) => {
    const [menuIndex,] = useSelectedMenuIndex()
    const levelLabel = menuLevelsDef[menuIndex].label
    const levelMenu = useRecoilValue(levelMenuState({ area, levelLabel }))
    return levelMenu
}

export const useMenuRepository = (area: string) => {
    const repo = useRecoilValue(sdForGroupState(area))
    return repo
}